// Cambridge Associates brand colors
// Source: CA Brand Guide

export const CA_BLUE = "#0C3980";
export const SKY = "#1E8AC8";
export const TEAL = "#26A299";
export const LIME = "#9CD441";
export const ORANGE = "#E78024";
export const GOLD = "#F3B900";
export const SAND = "#BEA57D";
export const CA_GRAY = "#A7A9AC";
export const PUNCH = "#D95666"; // Negative values / errors ONLY

// Tints
export const CA_BLUE_L80 = "#CED7E6";
export const CA_BLUE_L60 = "#9EB0CC";
export const CA_BLUE_D25 = "#092B60";
export const CA_BLUE_D40 = "#061D40";

export const SKY_L80 = "#D2E8F4";
export const SKY_L60 = "#A5D0E9";
export const SKY_L40 = "#78B9DE";
export const SKY_D25 = "#1C6893";
export const SKY_D40 = "#124663";

export const TEAL_L80 = "#D4ECEB";
export const TEAL_L60 = "#A8DAD6";
export const TEAL_L40 = "#7DC7C2";
export const TEAL_D25 = "#1D7A73";
export const TEAL_D40 = "#13514D";

export const LIME_L80 = "#EBF6D9";
export const LIME_L60 = "#D7EEB3";
export const LIME_L40 = "#C4E58D";
export const LIME_D25 = "#78A732";
export const LIME_D40 = "#506F21";

export const ORANGE_L80 = "#FAE6D3";
export const ORANGE_L60 = "#F5CCA7";
export const ORANGE_L40 = "#F1B37C";
export const ORANGE_D25 = "#B46014";
export const ORANGE_D40 = "#78400D";

export const GOLD_L80 = "#F2EDE5";
export const GOLD_L60 = "#E5DBCB";
export const GOLD_L40 = "#D8C9B1";
export const GOLD_D25 = "#B5891D";
export const GOLD_D40 = "#675436";

export const GRAY_L80 = "#EDEEEE";
export const GRAY_L60 = "#DCDDDD";
export const GRAY_L40 = "#CACBCD";
export const GRAY_D25 = "#7E7E83";
export const GRAY_D40 = "#525457";
